const PREFIX = "COMMON_ASSESSMENT";

export const commonActionTypes = {
  discard: `${PREFIX}_DISCARD`,
};
